module.exports = __webpack_public_path__ + "img/bk_01.7f3a03ba.png";